import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {HttpClient} from "@angular/common/http";

export interface MenuSet {
  readonly id: number;
  readonly title: string
  readonly description: string;
  readonly preparation: number;
  readonly duration: number;
  readonly price: string;
  readonly min_total_amount: string;
  readonly is_active: boolean;
  readonly url: string;
}

@Injectable()
export class MenuSetsService {

  constructor(private http: HttpClient) {
  }

  getMenuSetsList(): Observable<MenuSet[]> {
    return this.http.get<MenuSet[]>('/menu-sets');
  }

  getMenuSetDetails(menuSetId: number): Observable<MenuSet> {
    return this.http.get<MenuSet>(`/menu-sets/${menuSetId}`);
  }

  updateMenuSet(menuSet: MenuSet): Observable<any> {
    return this.http.put(`/menu-sets/${menuSet.id}`, menuSet);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/menu-sets.service.ts